import React, { HTMLAttributes, ReactNode } from 'react';

export interface PageTitleProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: ReactNode;
}

const PageTitle = ({ title, className, ...props }: PageTitleProps) => {
  return (
    <h2
      className={`textcolor text-2xl font-bold ${className}`}
      {...props}>
      {title}
    </h2>
  );
};

export default PageTitle;
